module.exports = __webpack_public_path__ + "static/media/videoEditor-11.0698e5d4.webp";